import { Link, useLocation } from "react-router-dom";

import styled from "styled-components";
import contactIcon from "../assets/contact.svg";
import homeIcon from "../assets/home.svg";
import aboutMeIcon from "../assets/icons8-more-info-100.svg";
import projectsIcon from "../assets/icons8-work-100.svg";
import { useGlobaleContext } from "../context";

//

const Sidebar = () => {
  const { pathname } = useLocation();

  const { isSidebarOpen, toggleSidebar } = useGlobaleContext();

  return (
    <SidebarContainer className={`${isSidebarOpen ? "show-sidebar" : ""}`}>
      <aside
        className={`${isSidebarOpen ? "sidebar show-sidebar" : "sidebar"}`}
      >
        {/* <div className="sidebar-header">
                <Link to="/" className="logo__link">
                    <img className='logo__image' src={logo} alt="logo" />
                </Link>
            </div> */}
        <ul className="sidebar-links">
          <li className="sidebar-link ">
            <Link
              to="/"
              onClick={() => {
                toggleSidebar();
              }}
              className={pathname === "/" ? "active_page" : null}
              tabIndex={isSidebarOpen ? 0 : -1}
            >
              <img alt="" src={homeIcon} /> <span>Home</span>
            </Link>
          </li>
          <li className="sidebar-link">
            <Link
              to="/about"
              onClick={() => {
                toggleSidebar();
              }}
              className={pathname === "/about" ? "active_page" : null}
              tabIndex={isSidebarOpen ? 1 : -1}
            >
              <img alt="" src={aboutMeIcon} /> <span>About Me</span>
            </Link>
          </li>
          <li className="sidebar-link">
            <Link
              to="/projects"
              onClick={() => {
                toggleSidebar();
              }}
              className={pathname === "/projects" ? "active_page" : null}
              tabIndex={isSidebarOpen ? 2 : -1}
            >
              <img alt="" src={projectsIcon} /> <span>My Projects</span>
            </Link>
          </li>
          <li className="sidebar-link">
            <Link
              to="/contact"
              onClick={() => {
                toggleSidebar();
              }}
              className={pathname === "/contact" ? "active_page" : null}
              tabIndex={isSidebarOpen ? 3 : -1}
            >
              <img alt="" src={contactIcon} />
              <span>Contact Me</span>
            </Link>
          </li>
          <li className="sidebar-link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter Account"
              href="https://drive.google.com/file/d/1TpovMsJhxuPV77cxoP31SZpOs-1dJCdB/view?usp=sharing"
              tabIndex={isSidebarOpen ? 4 : -1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="64px"
                height="64px"
                fill="currentColor"
              >
                <circle cx="49" cy="29.5" r="4" fill="#3e3ef4" />
                <path
                  fill="#3e3ef4"
                  d="M49,17.5A14.5,14.5,0,1,0,63.5,32,14.51669,14.51669,0,0,0,49,17.5Zm6,25A1.50008,1.50008,0,0,1,53.5,41a4.5,4.5,0,0,0-9,0,1.5,1.5,0,0,1-3,0,7.48738,7.48738,0,0,1,3.10162-6.06189,7,7,0,1,1,8.79676,0A7.48738,7.48738,0,0,1,56.5,41,1.50007,1.50007,0,0,1,55,42.5Z"
                />
                <path d="M.94049,49.06158,14.9386,63.05969A1.53388,1.53388,0,0,0,16,63.5H43A4.50491,4.50491,0,0,0,47.5,59V50.73926a1.5,1.5,0,0,0-3,0V59A1.50164,1.50164,0,0,1,43,60.5H17.5V51A4.50491,4.50491,0,0,0,13,46.5H3.5V5A1.50164,1.50164,0,0,1,5,3.5H43A1.50164,1.50164,0,0,1,44.5,5v8.26074a1.5,1.5,0,0,0,3,0V5A4.50491,4.50491,0,0,0,43,.5H5A4.50491,4.50491,0,0,0,.5,5V48A1.508,1.508,0,0,0,.94049,49.06158ZM14.5,51v7.37891L5.62109,49.5H13A1.50164,1.50164,0,0,1,14.5,51Z" />
                <path d="M24,6.5H8a1.5,1.5,0,0,0,0,3H24a1.5,1.5,0,0,0,0-3Z" />
                <path d="M19.5,14A1.50007,1.50007,0,0,0,18,12.5H8a1.5,1.5,0,0,0,0,3H18A1.50007,1.50007,0,0,0,19.5,14Z" />
                <path d="M12,18.5A5.5,5.5,0,1,0,17.5,24,5.50654,5.50654,0,0,0,12,18.5Zm0,8A2.5,2.5,0,1,1,14.5,24,2.50263,2.50263,0,0,1,12,26.5Z" />
                <path d="M31,19.5H21a1.5,1.5,0,0,0,0,3H31a1.5,1.5,0,0,0,0-3Z" />
                <path d="M21,28.5h6a1.5,1.5,0,0,0,0-3H21a1.5,1.5,0,0,0,0,3Z" />
                <path d="M12,32.5A5.5,5.5,0,1,0,17.5,38,5.50654,5.50654,0,0,0,12,32.5Zm0,8A2.5,2.5,0,1,1,14.5,38,2.50263,2.50263,0,0,1,12,40.5Z" />
                <path d="M32.5,35A1.50007,1.50007,0,0,0,31,33.5H21a1.5,1.5,0,0,0,0,3H31A1.50007,1.50007,0,0,0,32.5,35Z" />
                <path d="M21,39.5a1.5,1.5,0,0,0,0,3h6a1.5,1.5,0,0,0,0-3Z" />
                <path d="M39.5,49A1.50007,1.50007,0,0,0,38,47.5H21a1.5,1.5,0,0,0,0,3H38A1.50007,1.50007,0,0,0,39.5,49Z" />
                <path d="M21,53.5a1.5,1.5,0,0,0,0,3H34a1.5,1.5,0,0,0,0-3Z" />
              </svg>
              <span>Resume</span>
            </a>
          </li>
        </ul>
      </aside>
    </SidebarContainer>
  );
};
const SidebarContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99;
  transform: translateX(100%);
  opacity: 0;
  transition: var(--transition), opacity 0.3s ease-out;
  background-color: hsl(0 0% 0% /0.1);
  &.show-sidebar {
    transform: translateX(0) !important;
    opacity: 1;
  }

  aside {
    background-color: var(--colors-white);
    position: fixed;
    inset: 0 0 0 40%;
    transition: var(--transition);
  }

  .sidebar-header {
    display: flex;
    justify-content: space-between;
    padding: 4px;
  }
  .sidebar-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1rem;

    width: 100%;
    margin: auto;
    margin-top: 15vh;
  }
  .sidebar-link {
    width: 100%;
    transition: var(--transition);
  }

  .sidebar-link a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    gap: 1rem;
    justify-content: flex-start;
    margin-left: 1rem;
    transition: var(--transition);
    padding: 1rem;
  }
  .sidebar-link:hover {
    background: var(--clr-grey-10);
  }
  .sidebar-link a:hover {
    padding-left: 2rem;
    color: var(--clr-grey-2);
  }

  .sidebar-link a img,
  svg {
    width: 3rem;
  }

  .active_page {
    color: var(--colors-accent-300);
  }

  @media (max-width: 635px) {
    aside {
      inset: 0 0 0 20%;
    }
  }

  /* black bg
&::after{
    content: '';
    z-index: -1;
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    transition: var(--transition);
    transition-delay: 0.2s;
}
&.show-sidebar::after{
    opacity: 1;
} */
`;
export default Sidebar;
